import React from "react";
import { connect } from "react-redux";
import {
  PROVIDER_ROOM_PROCEDURE_TYPE,
  PROVIDER_ROOM_PROCEDURE_VERSION,
} from "../../../api/queries/useProviderRoomProceduresQuery";
import { useProcedures } from "../hooks/useProcedures";
import { TabCosmetic } from "./components/TabCosmetic";
import { TabHealth } from "./components/TabHealth";
import { Layout } from "../components/Layout/Layout";
import { useApiClinics } from "../../Event/hooks/useApiClinics";
import { providerRoom } from "../../../store/providerRoom";

function mapStateToProps(state) {
  return {
    activeTab: providerRoom.selectors.selectCurrentTab(state),
    isSigning: providerRoom.selectors.selectProcedureSigningStatus(state),
    isSigned: providerRoom.selectors.selectProcedureSignedStatus(state),
  };
}

export const TabSignedProcedures = connect(mapStateToProps)(
  ({ history, activeTab, isSigning, isSigned }) => {
    const historyData = history?.location?.state;
    const chartAuditUserId = historyData?.chartUserId?.toString();
    const {
      procedures,
      fetchNextProcedures,
      proceduresStatus,
      proceduresSearchTerm,
      proceduresType,
      selectClinic,
      showAllProcedures,
    } = useProcedures({
      version: PROVIDER_ROOM_PROCEDURE_VERSION.signed,
      clinicID: historyData?.clinic_id,
      providerUserId: chartAuditUserId,
      activeProcedureTab: activeTab,
    });

    const { clinics: availableClinicsList } = useApiClinics();

    const tabByType = {
      [PROVIDER_ROOM_PROCEDURE_TYPE.cosmetic]: (
        <TabCosmetic
          isVisible={proceduresStatus.isVisible}
          onChangeTab={proceduresType.onChange}
          procedures={procedures}
          availableClinicsList={availableClinicsList}
          onChangeClinic={selectClinic.onChange}
          clinicId={selectClinic.value}
          isShowAllProcedures={showAllProcedures.value}
          onChangeShowAllProcedures={showAllProcedures.onChange}
          showHideActionButton={Boolean(historyData?.isFromChartAuditReport)}
          providerUserId={chartAuditUserId}
          isSigning={isSigning}
          isSigned={isSigned}
        />
      ),
      [PROVIDER_ROOM_PROCEDURE_TYPE.health]: (
        <TabHealth
          isVisible={proceduresStatus.isVisible}
          onChangeTab={proceduresType.onChange}
          procedures={procedures}
          availableClinicsList={availableClinicsList}
          onChangeClinic={selectClinic.onChange}
          clinicId={selectClinic.value}
          isShowAllProcedures={showAllProcedures.value}
          onChangeShowAllProcedures={showAllProcedures.onChange}
          showHideActionButton={Boolean(historyData?.isFromChartAuditReport)}
          providerUserId={chartAuditUserId}
          isSigning={isSigning}
          isSigned={isSigned}
        />
      ),
    };
    return (
      <Layout
        search={proceduresSearchTerm}
        status={proceduresStatus}
        loadMore={fetchNextProcedures}
      >
        {tabByType[activeTab] ||
          tabByType[PROVIDER_ROOM_PROCEDURE_TYPE.cosmetic]}
      </Layout>
    );
  },
);
